import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class OpenTimerModelAction extends BaseAction<void, { isTimerVisible: boolean }> {
  override async run(): Promise<void> {
    const { isTimerVisible } = this.params!;
    
    updateRecoilState("isTimerVisibleAtom", isTimerVisible);
  }
}

// Create a singleton instance
export const openTimerModelAction = new OpenTimerModelAction();
